/* Magnet Pix theme. Small progressive enhancements only; every feature works without this file. */
(function () {
  'use strict';

  /* Collection filters: open on desktop, submit sort changes straight away */
  function initFilters() {
    var details = document.querySelector('[data-filters]');
    if (details && window.matchMedia('(min-width: 990px)').matches) details.open = true;

    document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
      el.addEventListener('change', function () {
        if (el.form) el.form.submit();
      });
    });
  }

  /* Photo upload: one multi-file picker that fills the numbered file inputs */
  function PhotoUpload(root) {
    this.root = root;
    this.required = parseInt(root.dataset.required, 10) || 0;
    this.maxBytes = (parseFloat(root.dataset.maxMb) || 10) * 1024 * 1024;
    this.fields = Array.prototype.slice.call(root.querySelectorAll('[data-photo-field]'));
    this.picker = root.querySelector('[data-picker]');
    this.input = root.querySelector('[data-picker-input]');
    this.thumbs = root.querySelector('[data-thumbs]');
    this.status = root.querySelector('[data-status]');
    this.error = root.querySelector('[data-error]');
    this.form = root.closest('form');
    this.strings = JSON.parse(root.querySelector('[data-strings]').textContent);
    this.files = [];
    this.urls = [];

    if (!this.canAssignFiles()) return;

    this.enhance();
  }

  PhotoUpload.prototype.canAssignFiles = function () {
    try {
      var dt = new DataTransfer();
      dt.items.add(new File(['x'], 'x.jpg', { type: 'image/jpeg' }));
      return dt.files.length === 1;
    } catch (e) {
      return false;
    }
  };

  PhotoUpload.prototype.t = function (key, vars) {
    var str = this.strings[key] || '';
    Object.keys(vars || {}).forEach(function (k) {
      str = str.split('__' + k.toUpperCase() + '__').join(vars[k]);
    });
    return str;
  };

  PhotoUpload.prototype.enhance = function () {
    var self = this;
    var fieldsWrap = this.root.querySelector('[data-fields]');
    fieldsWrap.setAttribute('data-enhanced', '');
    this.fields.forEach(function (f) {
      f.required = false;
      f.tabIndex = -1;
    });
    this.picker.hidden = false;

    this.input.addEventListener('change', function () {
      self.add(Array.prototype.slice.call(self.input.files));
      self.input.value = '';
    });

    this.thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove]');
      if (!btn) return;
      self.files.splice(parseInt(btn.dataset.remove, 10), 1);
      self.sync();
      self.input.focus();
    });

    if (this.form) {
      var btn = this.form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';

      this.form.addEventListener('submit', function (e) {
        if (self.submitting) {
          e.preventDefault();
          return;
        }
        if (self.files.length < self.required) {
          e.preventDefault();
          self.showError(self.t('missing', { total: self.required }));
          self.input.focus();
          return;
        }
        self.submitting = true;
        if (btn) {
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = self.strings.uploading;
        }
      });

      // Coming back with the browser Back button restores the page from cache; reset the button
      window.addEventListener('pageshow', function () {
        self.submitting = false;
        if (btn) {
          btn.removeAttribute('aria-disabled');
          btn.textContent = label;
        }
      });
    }

    this.sync();
  };

  PhotoUpload.prototype.isAllowed = function (file) {
    var name = file.name.toLowerCase();
    return /\.(jpe?g|png|heic|heif)$/.test(name) || /^image\/(jpeg|png|heic|heif)$/.test(file.type);
  };

  PhotoUpload.prototype.add = function (incoming) {
    var self = this;
    var errors = [];
    incoming.forEach(function (file) {
      if (!self.isAllowed(file)) {
        errors.push(self.t('type', { name: file.name }));
      } else if (file.size > self.maxBytes) {
        errors.push(self.t('size', { name: file.name }));
      } else if (self.files.length >= self.required) {
        if (errors.indexOf(self.strings.too_many) === -1) errors.push(self.strings.too_many);
      } else {
        self.files.push(file);
      }
    });
    this.showError(errors.join(' '));
    this.sync();
  };

  PhotoUpload.prototype.showError = function (msg) {
    this.error.textContent = msg || '';
  };

  PhotoUpload.prototype.sync = function () {
    var self = this;

    this.fields.forEach(function (field, i) {
      var dt = new DataTransfer();
      if (self.files[i]) dt.items.add(self.files[i]);
      field.files = dt.files;
    });

    this.urls.forEach(function (u) {
      URL.revokeObjectURL(u);
    });
    this.urls = [];
    this.thumbs.innerHTML = '';

    this.files.forEach(function (file, i) {
      var li = document.createElement('li');
      var isHeic = /\.(heic|heif)$/i.test(file.name);
      if (!isHeic) {
        var url = URL.createObjectURL(file);
        self.urls.push(url);
        var img = document.createElement('img');
        img.src = url;
        img.alt = file.name;
        li.appendChild(img);
      } else {
        li.textContent = file.name;
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'photo-upload__remove';
      btn.dataset.remove = i;
      btn.setAttribute('aria-label', self.t('remove', { name: file.name }));
      btn.textContent = '×';
      li.appendChild(btn);
      self.thumbs.appendChild(li);
    });

    this.status.textContent = this.t('count', { added: this.files.length, total: this.required });
  };

  /* Motion: scroll reveals, scroll-linked scenes and the header's scroll states.
     Native scrolling is never taken over; this only reads the scroll position once per frame.
     Nothing runs when the shopper has asked their device for reduced motion. */
  function initMotion() {
    if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var root = document.documentElement;
    root.classList.add('motion');

    var vh = window.innerHeight;
    var header = document.querySelector('.site-header-section');
    var phone = window.matchMedia('(max-width: 989px)');
    var lastY = window.scrollY;
    var ticking = false;

    /* Reveal: content below the screen fades and rises in as it arrives. When one item in a
       row arrives, the rest of its row comes with it (staggered), which also covers swipe rows. */
    var revealSelector = [
      '.section-header',
      '.grid > li',
      '.trust__item',
      '.steps > li',
      '.tiers > li',
      '.tiers-note',
      '.options-grid > li',
      '.swatches > li',
      '.about-blurb .page-width > *',
      '.cta-band .page-width > *',
      '.b2b-split > *',
      '.accordion'
    ].join(',');

    function show(el) {
      el.classList.add('is-in');
      revealer.unobserve(el);
    }

    var revealer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          show(entry.target);
          Array.prototype.forEach.call(entry.target.parentNode.children, function (sib) {
            if (sib.classList.contains('reveal') && !sib.classList.contains('is-in') && sib.getBoundingClientRect().top < vh) show(sib);
          });
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );

    document.querySelectorAll(revealSelector).forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) return;
      var index = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--d', (index % 4) * 90 + 'ms');
      el.classList.add('reveal');
      revealer.observe(el);
    });

    /* Scroll-linked scenes. Each [data-scrub] element gets --p, its progress from 0 to 1:
       hero  - from the top of the page until the photo reaches the top of the screen
       pin   - while a tall section's pinned inner stays on screen
       line  - as the element passes a line just above the middle of the screen
       view  - the whole time the element is on screen */
    var scenes = [];
    document.querySelectorAll('[data-scrub]').forEach(function (el) {
      scenes.push({ el: el, mode: el.getAttribute('data-scrub') || 'view', steps: el.querySelectorAll('[data-step]'), p: -1, near: false });
    });

    var nearby = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          scenes.forEach(function (s) {
            if (s.el === entry.target) s.near = entry.isIntersecting;
          });
        });
        update();
      },
      { rootMargin: '25% 0px 25% 0px' }
    );

    function measure() {
      vh = window.innerHeight;
      scenes.forEach(function (s) {
        var grow = s.el.querySelector('[data-grow]');
        if (!grow) return;
        grow.style.setProperty('--grow', Math.min(document.documentElement.clientWidth / grow.offsetWidth, 1.4).toFixed(4));
        s.growTop = grow.getBoundingClientRect().top + window.scrollY;
      });
    }

    function progress(s) {
      var r = s.el.getBoundingClientRect();
      if (s.mode === 'hero') return window.scrollY / Math.max(1, s.growTop - vh * 0.1);
      if (s.mode === 'pin') return -r.top / Math.max(1, r.height - vh);
      if (s.mode === 'line') return (vh * 0.6 - r.top) / Math.max(1, r.height);
      return (vh - r.top) / (vh + r.height);
    }

    function render() {
      ticking = false;

      scenes.forEach(function (s) {
        if (!s.near && s.mode !== 'hero') return;
        var p = Math.min(1, Math.max(0, progress(s)));
        if (Math.abs(p - s.p) < 0.001) return;
        s.p = p;
        s.el.style.setProperty('--p', p.toFixed(4));

        if (s.steps.length) {
          var active = 0;
          Array.prototype.forEach.call(s.steps, function (step, i) {
            var on = step.getBoundingClientRect().top < vh * 0.6;
            step.classList.toggle('is-active', on);
            if (on) active = i + 1;
          });
          var host = s.el.closest('[data-steps-host]');
          if (host) host.setAttribute('data-active', Math.max(1, active));
        }
      });

      /* Header: firmer once scrolled; on phones it slides away going down and returns going up */
      var y = window.scrollY;
      if (header) {
        header.classList.toggle('is-scrolled', y > 8);
        if (!phone.matches || y < 240 || header.querySelector('details[open]')) {
          header.classList.remove('is-hidden');
          lastY = y;
        } else if (Math.abs(y - lastY) > 8) {
          header.classList.toggle('is-hidden', y > lastY);
          lastY = y;
        }
      }
    }

    function update() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    }

    measure();
    scenes.forEach(function (s) {
      nearby.observe(s.el);
    });
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () {
      measure();
      update();
    });
    if (header) header.addEventListener('focusin', function () {
      header.classList.remove('is-hidden');
    });
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMotion();
    initFilters();
    document.querySelectorAll('[data-photo-upload]').forEach(function (el) {
      new PhotoUpload(el);
    });
  });
})();
